export function scrollToBottomRef(ref: any) {
    ref.current?.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
}
